import { createAnimation } from '@ionic/core';
import { Component, Prop, h, Element, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'og-loading',
  styleUrl: 'loading.scss',
  shadow: true,
})
export class Loading implements ComponentInterface {
  @Element() el!: HTMLOgLoadingElement;

  @Prop() text?: string[];

  componentDidLoad() {
    if (!this.text || this.text.length < 2) return;
    this.animateMessageList();
  }

  async animateMessageList() {
    const items = this.el.shadowRoot?.querySelectorAll('span');
    const nodes: HTMLSpanElement[] = [];
    if (!items) return;
    items.forEach(item => nodes.push(item));
    for (const item of nodes) {
      const index = nodes.indexOf(item);
      const lastItem = index === nodes.length - 1;
      const animation = createAnimation()
        .beforeStyles({ display: 'inherit' })
        .addElement(item)
        .duration(4500)
        .keyframes([
          {
            offset: 0,
            opacity: '0',
            transform: 'translateY(-5px) scale(.9)',
          },
          {
            offset: 0.05,
            opacity: '1',
            transform: 'translateY(0px) scale(1)',
          },
          {
            offset: 0.95,
            opacity: '1',
            transform: 'translateY(0px) scale(1)',
          },
          {
            offset: 1,
            opacity: lastItem ? '1' : '0',
            transform: lastItem
              ? 'translateY(0px) scale(1)'
              : 'translateY(-5px) scale(.9)',
          },
        ]);
      lastItem
        ? await animation.play() // don't hide last item
        : await animation.afterStyles({ display: 'none' }).play();
    }
  }

  render() {
    return (
      <div>
        <og-logo animated={true} />
        {this.text
          ? this.text.map((message, i) => (
              <span style={{ display: i > 0 ? 'none' : 'inherit' }}>
                {message}
              </span>
            ))
          : null}
      </div>
    );
  }
}
